import useABTestV2 from '@/utils/abtest/useABTestV2'
import { ISSUE_434_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'

/**
 * A/Bテストの設定に基づいておすすめイベント順序タイプを取得する
 * @param {Object} pageDetector - PageDetectorのインスタンス
 * @param {boolean} hasAlreadyAppliedAIRecommendPrefecturesInSearchParams - 検索パラメータにAIおすすめ都道府県が適用済みかどうか
 * @returns {string|null} おすすめイベント順序タイプ ('v1', 'v2', 'v3') または null
 */
export const getRecommendEventOrderType = (
  pageDetector,
  hasAlreadyAppliedAIRecommendPrefecturesInSearchParams
) => {
  const { isAPattern: issue434IsAPattern, isBPattern: issue434IsBPattern } = useABTestV2(ISSUE_434_AB_TEST_CONFIG)
  
  if (issue434IsAPattern || issue434IsBPattern) {
    if (pageDetector.isSearchPageWithAlreadyAppliedAIRecommendRegion || hasAlreadyAppliedAIRecommendPrefecturesInSearchParams) {
      // 東京: A群（ai_recommend_v2）、B群（ai_recommend_v3）
      return issue434IsBPattern ? 'v3' : 'v2'
    } else {
      // 東京以外: A群（ai_recommend）、B群（ai_recommend_v3）
      return issue434IsBPattern ? 'v3' : 'v1'
    }
  } else if (pageDetector.isSearchPageWithAlreadyAppliedAIRecommendRegion || hasAlreadyAppliedAIRecommendPrefecturesInSearchParams) {
    // issue-345: 東京はいつもおすすめ順 B pattern (既存ロジック維持)
    return 'v2'
  }

  return null
}